// extracted by mini-css-extract-plugin
export default {"rowHead":"RowHeadTable_rowHead__5QiVm"};